import React, { useState } from 'react';
import { Badge, Avatar, Popover, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import LogoutModal from '../modal/logout';

//----------------------------------------------------------------------------------------------------
import icoProfile from '../../assets/images/ico_profile.png';
import icoLogout from '../../assets/images/ico_logout.png';
//----------------------------------------------------------------------------------------------------
// const text = <span>Title</span>;
function TitleComponent(props) {
  const { principal, setOpen } = props;
  // console.log('-[principal]--->', principal);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '1rem',
        borderBottom: '1px solid #DBDADE',
        margin: 0,
      }}
      onClick={(e) => {
        setOpen(false);
      }}
    >
      <div
        style={{
          display: 'flex',
          width: '3.8rem',
          flexDirection: 'column',
          alignItems: 'end',
        }}
      >
        <Avatar
          shape="circle"
          icon={<img width={24} height={24} src={props.icon} />}
        />
        {props.show && (
          <Badge
            // count={show ? 109 : 0}
            style={{
              position: 'absolute',
              backgroundColor: '#52c41a',
              width: '0.7rem',
              height: '0.7rem',
              marginTop: '-0.5rem',
              marginRight: '0.8rem',
            }}
            dot
          />
        )}
      </div>
      <div
        style={{
          display: 'flex',
          marginLeft: '2rem',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        <div
          style={{
            fontFamily: 'Public Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '1.5rem',
            lineHeight: '2.2rem',
          }}
        >
          {(principal && principal.name) || 'Empty'}
        </div>
        <div
          style={{
            fontFamily: 'Public Sans',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '1.3rem',
            lineHeight: '2rem',
          }}
        >
          {(principal && principal.role) || 'Empty'}
        </div>
      </div>
    </div>
  );
}
//----------------------------------------------------------------------------------------------------
function ContentComponent(props) {
  const { gModal, setGModal, principal, adminName = 'Empty', setOpen } = props;
  // console.log('--->', props);
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          marginTop: '-0.7rem',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          icon={
            <img
              width={24}
              height={24}
              src={icoProfile}
              style={{ marginRight: '1rem' }}
            />
          }
          onClick={(e) => {
            setOpen(false);
            // Route.Link('/admins');
            navigate('admins', { replace: false });
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
          >
            Profile
          </div>
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '0rem 0rem 0rem 0rem',
          // borderBottom: '1px solid #DBDADE',
          borderRadius: 0,
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          icon={
            <img
              width={24}
              height={24}
              src={icoLogout}
              style={{ marginRight: '1rem' }}
            />
          }
          onClick={(e) => {
            setOpen(false);
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: <LogoutModal {...props} />,
              };
            });
          }}
          size="middle"
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
          >
            Logout
          </div>
        </Button>
      </div>
    </div>
  );
}
//----------------------------------------------------------------------------------------------------
const BaseAvatar = (props) => {
  // bage
  const [show, setShow] = useState(true);
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        width: '3.8rem',
        flexDirection: 'column',
        alignItems: 'end',
        // padding: 0,
      }}
    >
      <Popover
        // overlayStyle={{ padding: 0 }}
        // className="ant-popover-inner-content"
        overlayInnerStyle={{ padding: 0, width: '23rem', margin: 0 }}
        placement="bottomRight"
        title={TitleComponent({ ...props, show, setOpen })}
        content={ContentComponent({ ...props, show, setOpen })}
        trigger="click"
        showArrow={false}
        open={open}
      >
        <Avatar
          shape="circle"
          onClick={(e) => {
            setOpen((prev) => !prev);
          }}
          icon={<img width={24} height={24} src={props.icon} />}
        />
      </Popover>

      {show && (
        <Badge
          // count={show ? 109 : 0}
          style={{
            position: 'absolute',
            backgroundColor: '#52c41a',
            width: '0.7rem',
            height: '0.7rem',
            marginTop: '-0.5rem',
            marginRight: '0.8rem',
          }}
          dot
        />
      )}
    </div>
  );
};

export default BaseAvatar;
